
module.exports = {
  find_water: {
    title: 'FIND WATER',
    description: 'Gather some water in the river',
    icon: 'water',
    isDisabled (player, store) {
      return player.action !== null
    },
    isHidden (player, store) {
      return false
    }
  },
  find_food: {
    title: 'FIND FOOD',
    description: 'Find any kind of food',
    icon: 'food',
    isDisabled (player, store) {
      return player.action !== null
    },
    isHidden (player, store) {
      return player.status.thirsty
    }
  },
  find_wood: {
    title: 'FIND WOOD',
    description: 'Find any stash of wood',
    icon: 'wood',
    isDisabled (player, store) {
      return player.action !== null
    },
    isHidden (player, store) {
      return player.status.thirsty || player.status.hungry
    }
  },
  find_stone: {
    title: 'FIND STONE',
    description: 'Find any stone around',
    icon: 'stone',
    isDisabled (player, store) {
      return player.action !== null
    },
    isHidden (player, store) {
      return player.status.thirsty || player.status.hungry
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/ActionWidgetConfig.js